import React, { useContext } from 'react';
import PropTypes from 'prop-types'
import StatisticsContentComponent from './StatisticsContent/StatisticsContent.container';
import { I18nContext } from 'utils/I18n/context';

const StatisticsPage = ({ location }) => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.reportPage || { title: 'Statistics' };

    return (
        <div className="statistics" id="statisticsPage">
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <StatisticsContentComponent
                location={location}
            />
        </div>
    );
};

StatisticsPage.propTypes = {
    location: PropTypes.object
};

export default StatisticsPage;
